import {
  PortfolioTopPriorityTask,
  PortfolioTopPriorityTaskByProjectId,
  Project
} from 'interfaces/project.interface';

export const buildTopPriorityTaskMap = (
  entries: ReadonlyArray<readonly [string, PortfolioTopPriorityTask | null]>
): PortfolioTopPriorityTaskByProjectId => Object.fromEntries(entries);

export const getTopPriorityTaskForProject = (
  map: PortfolioTopPriorityTaskByProjectId,
  projectId: string
): PortfolioTopPriorityTask | null => map[projectId] ?? null;

export const hasSeededTopPriorityTask = (
  project: Pick<Project, 'top_priority_task'>
): boolean => 'top_priority_task' in project;

/** Seed UI cache from GET /projects `top_priority_task` (including explicit null). */
export const buildTopPriorityTaskMapFromProjects = (
  projects: ReadonlyArray<Pick<Project, 'id' | 'top_priority_task'>>
): PortfolioTopPriorityTaskByProjectId =>
  Object.fromEntries(
    projects
      .filter(hasSeededTopPriorityTask)
      .map((project) => [project.id, project.top_priority_task ?? null])
  );

export const mergeTopPriorityTasksFromProjects = (
  cachedByProjectId: PortfolioTopPriorityTaskByProjectId,
  projects: ReadonlyArray<Pick<Project, 'id' | 'top_priority_task'>>
): PortfolioTopPriorityTaskByProjectId => ({
  ...cachedByProjectId,
  ...buildTopPriorityTaskMapFromProjects(projects)
});
